import { getDesignDataByDesignAreaIdentifier } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { find, first } from 'lodash';

export function getSelectedDesignProductionMethodForDesignArea(designArea) {
  if (!designArea) {
    return '';
  }
  const designProductionMethods = designArea.designProductionMethods;
  const designAreaData = getDesignDataByDesignAreaIdentifier(Services.store.state, designArea.identifier);
  const { designProductionMethodIdentifier } = designAreaData;
  return (
    find(designProductionMethods, { identifier: designProductionMethodIdentifier }) ||
    first(designProductionMethods)
  );
}
